module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "application",
    attrs: {
      "id": "application"
    },
    on: {
      "focusin": function($event) {
        _vm.focusinHandler($event)
      }
    }
  }, [_c('div', {
    ref: "pages",
    staticClass: "pages"
  }, [_c('page-splash', {
    staticClass: "page--type2",
    attrs: {
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageSplashNextHandler,
      "uitleg": _vm.uitlegHandler
    }
  }), _vm._v(" "), _c('page-intro', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIntro),
      expression: "showIntro"
    }],
    attrs: {
      "show-page": _vm.showIntro,
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageIntroNextHandler
    }
  }), _vm._v(" "), _c('page-wat-is', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIntro),
      expression: "showIntro"
    }],
    attrs: {
      "show-page": _vm.showIntro,
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageWatIsNextHandler
    }
  }), _vm._v(" "), _c('page-actueel-thema', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIntro),
      expression: "showIntro"
    }],
    attrs: {
      "show-page": _vm.showIntro,
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageActueelThemaHandler
    }
  }), _vm._v(" "), _c('page-bekenden', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIntro),
      expression: "showIntro"
    }],
    attrs: {
      "show-page": _vm.showIntro,
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageBekendenNextHandler
    }
  }), _vm._v(" "), _c('page-soorten', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSoorten),
      expression: "showSoorten"
    }],
    staticClass: "page--type1",
    attrs: {
      "scroller": _vm.scroller
    },
    on: {
      "next": _vm.pageSoortenNextHandler
    }
  }), _vm._v(" "), _c('page-ten-eerste', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTenEerste),
      expression: "showTenEerste"
    }],
    attrs: {
      "show-page": _vm.showTenEerste,
      "job-types": _vm.jobTypes1,
      "scroller": _vm.scroller
    },
    on: {
      "profileupdate": _vm.profileUpdateHandler,
      "next": _vm.pageTenEersteNextHandler
    }
  }), _vm._v(" "), _c('page-wil-combineren', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWilCombineren),
      expression: "showWilCombineren"
    }],
    attrs: {
      "job-types": _vm.jobTypes2
    },
    on: {
      "profileupdate": _vm.profileUpdateHandler,
      "next": _vm.pageWilCombinerenNextHandler
    }
  }), _vm._v(" "), _c('page-niveau', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNiveau),
      expression: "showNiveau"
    }],
    attrs: {
      "show-page": _vm.showNiveau,
      "scroller": _vm.scroller
    },
    on: {
      "profileupdate": _vm.profileUpdateHandler,
      "next": _vm.pageNiveauNextHandler
    }
  }), _vm._v(" "), _c('page-lesgeven', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLesgeven),
      expression: "showLesgeven"
    }],
    attrs: {
      "vakken": _vm.vacatureDruk
    },
    on: {
      "next": function($event) {
        _vm.goTo('#page-lesbevoegdheid')
      },
      "profileupdate": _vm.profileUpdateHandler
    }
  }), _vm._v(" "), _c('page-lesbevoegdheid', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLesbevoegdheid),
      expression: "showLesbevoegdheid"
    }],
    attrs: {
      "user-profile": _vm.userProfile,
      "vakken": _vm.vacatureDruk
    },
    on: {
      "profileupdate": _vm.profileUpdateHandler,
      "next": function($event) {
        _vm.goTo('#page-dagen-kiezen')
      }
    }
  }), _vm._v(" "), _c('page-dagen-kiezen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDagenKiezen),
      expression: "showDagenKiezen"
    }],
    staticClass: "page--type2",
    attrs: {
      "user-profile": _vm.userProfile
    },
    on: {
      "next": _vm.pageDagenKiezenNextHandler,
      "profileupdate": _vm.profileUpdateHandler
    }
  }), _vm._v(" "), _c('page-combinatie', {
    attrs: {
      "user-profile": _vm.userProfile,
      "persons": _vm.urenVerdeling
    },
    on: {
      "next": function($event) {
        _vm.goTo('#page-quotes')
      }
    }
  }), _vm._v(" "), _c('page-quotes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQuotes),
      expression: "showQuotes"
    }],
    attrs: {
      "show-page": _vm.showQuotes,
      "user-profile": _vm.userProfile,
      "quotes": _vm.quotes
    },
    on: {
      "next": function($event) {
        _vm.goTo('#page-contact')
      }
    }
  }), _vm._v(" "), _c('page-contact', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContact),
      expression: "showContact"
    }],
    staticClass: "page--type2",
    attrs: {
      "submit-pending": _vm.submitPending,
      "user-profile": _vm.userProfile
    },
    on: {
      "profileupdate": _vm.profileUpdateHandler,
      "next": _vm.submitRegistration
    }
  }), _vm._v(" "), _c('page-slot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSlot),
      expression: "showSlot"
    }],
    staticClass: "page--type2",
    attrs: {
      "user-profile": _vm.userProfile
    }
  })], 1), _vm._v(" "), (_vm.userProfile.baan1) ? _c('profile', {
    attrs: {
      "user-profile": _vm.userProfile
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c197db78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/application/application.vue
// module id = 154
// module chunks = 0